import { render } from "./CalendarView.vue?vue&type=template&id=8bfeccbe&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=8bfeccbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8bfeccbe"

export default script